// src/components/auth-nav.js

import React from "react";
import AuthenticationButton from "./authentication-button";

const AuthNav = () => (
  <ul style={{ boxShadow: "none", padding: "0px" }} className="navbar-nav ml-auto">
    <AuthenticationButton />
  </ul>
);

export default AuthNav;
